// API Configuration - automatically uses correct backend based on current domain
const getApiUrl = () => {
  // In production (deployed), use relative URLs so cookies work
  // The /api prefix is handled by the server routing
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // If on custom domain or deployed site, use relative path
    if (hostname === 'dueday.org' || hostname === 'www.dueday.org' || hostname.endsWith('.emergent.host')) {
      return '/api';
    }
  }
  
  // For preview/development, use the environment variable
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  return backendUrl ? `${backendUrl}/api` : '/api';
};

export const API = getApiUrl();
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
